define(['models/RollbackModel'], function(RollbackModel) {
  return RollbackModel.extend({
    idAttribute: 'FilterCriteriaID',
    defaults: {
      _delete: false,
    },
  });
});
